const myIsNaN = (value) => {
    return typeof !!value && (typeof value === 'number') && !isNaN(value);
  }

const toThousands = (num) => {
    if( !myIsNaN(num) ) {
        return '0.00'
    }
    const _num = (num*1).toFixed(2)
    return (_num || 0).toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g,'$1,')
}

export default toThousands